const BACKGROUNDS = {
  dark: { bg: "#050505", text: "#ffffff", sub: "rgba(255,255,255,0.55)", accent: "#00FF66" },
  green: { bg: "#031a10", text: "#eafff3", sub: "rgba(234,255,243,0.6)", accent: "#00FF66" },
  light: { bg: "#f4f4f2", text: "#0a0a0a", sub: "rgba(0,0,0,0.55)", accent: "#0a0a0a" },
  violet: { bg: "#0d0620", text: "#f3ecff", sub: "rgba(243,236,255,0.6)", accent: "#b98bff" },
};

function btnStyle(style, t) {
  if (style === "outline") return { background: "transparent", color: t.text, border: `1.5px solid ${t.accent}`, borderRadius: 0 };
  if (style === "pill") return { background: t.accent, color: "#000", border: "none", borderRadius: 999 };
  return { background: t.accent, color: "#000", border: "none", borderRadius: 6 };
}

export default function HubPreview({ theme = {}, links = [] }) {
  const t = BACKGROUNDS[theme.background] || BACKGROUNDS.dark;
  const enabled = links.filter((l) => l.enabled !== false);

  return (
    <div className="mx-auto" style={{ width: 300 }} data-testid="hub-preview">
      <div className="border border-border overflow-hidden" style={{ borderRadius: 28, padding: 10, background: "#0a0a0a" }}>
        <div style={{ background: t.bg, color: t.text, borderRadius: 20, padding: "34px 20px 24px", minHeight: 460 }}>
          {theme.avatar_url ? (
            <img src={theme.avatar_url} alt="" style={{ width: 72, height: 72, borderRadius: 999, objectFit: "cover", border: `2px solid ${t.accent}`, margin: "0 auto 14px", display: "block" }} />
          ) : (
            <div style={{ width: 72, height: 72, borderRadius: 999, border: `2px dashed ${t.sub}`, margin: "0 auto 14px" }} />
          )}
          <p style={{ textAlign: "center", fontWeight: 800, fontSize: 18, letterSpacing: "-0.02em" }}>
            {theme.display_name || "Display name"}
          </p>
          {theme.bio && <p style={{ textAlign: "center", color: t.sub, fontSize: 12, margin: "8px 0 20px", lineHeight: 1.5 }}>{theme.bio}</p>}
          {!theme.bio && <div style={{ height: 16 }} />}
          {enabled.length === 0 && <p style={{ textAlign: "center", color: t.sub, fontSize: 12 }}>No links yet</p>}
          {enabled.map((l, i) => (
            <div key={l.id || i} style={{ ...btnStyle(theme.button_style, t), padding: "13px 16px", marginBottom: 11, fontWeight: 700, fontSize: 14, textAlign: "center" }}>
              {l.title || "Link"}
            </div>
          ))}
          {theme.affiliate_disclosure && (
            <p style={{ textAlign: "center", color: t.sub, fontSize: 10, marginTop: 18, lineHeight: 1.5 }}>
              {theme.disclosure_text || "Some links may be affiliate links; a purchase may earn a commission."}
            </p>
          )}
          <p style={{ textAlign: "center", color: t.sub, fontSize: 9, marginTop: 22, letterSpacing: "0.15em", textTransform: "uppercase" }}>Powered by D Code</p>
        </div>
      </div>
    </div>
  );
}
